import t from 'babel-plugin-yate/macro';
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Form, Field} from 'react-final-form';

import {getRedirectInstantPaymentApplication} from '../store/application';
import {getRedirectInstantPaymentTransaction} from '../store/transaction';
import {isRequired} from '../lib/validations';

import {Text} from '../components/uiElem';
import Button from '../components/Button';
import Modal from '../components/Modal';
import Checkbox from '../components/Form/Checkbox';

const ModalInstantPayment = ({id, header, data, uuid, appType}) => {
  const dispatch = useDispatch();
  const redirectInstantPayment = useCallback(async () => {
    let response = {};

    if (appType === 'online') {
      response = await dispatch(getRedirectInstantPaymentApplication(uuid));
    }

    if (appType === 'transaction') {
      response = await dispatch(getRedirectInstantPaymentTransaction(uuid));
    }

    if (response.status === 'success') {
      const redirectURL = response.data.endpoint;
      window.open(redirectURL, '_self');
    }
  }, [dispatch, uuid, appType]);

  const instantPaymentStatusMessage = status => {
    let message = '';
    switch (status) {
      case 'failed':
        message =
          'A intervenit o eroare la efectuarea tranzactiei. Va rugam reincercati.';
        break;
      case 'awaiting_bank_confirmation':
        message =
          'Ne pare rau, a intervenit o eroare la efectuarea tranzactiei. Pentru solutionare, va rugam sa ne contactati pe adresa de email crediteonline@credex-ifn.ro';
        break;
      default:
        message =
          'Pentru a va debursa creditul apasati butonul de jos pentru a completa datele cardului.';
        break;
    }
    return message;
  };

  return (
    <Modal id={id} header={header} width="max-w-lg" allowClose={false}>
      <div className="p-6">
        <Text className="text-center">
          {instantPaymentStatusMessage(data.instant_payment_status)}
        </Text>

        {data.instant_payment_status !== 'awaiting_bank_confirmation' && (
          <>
            <Text className="text-center">
              {t`Sunt permise doar carduri emise de banci romanesti.`}
            </Text>
            <Form
              keepDirtyOnReinitialize={true}
              onSubmit={redirectInstantPayment}
              render={({handleSubmit}) => (
                <>
                  <div className="py-6 text-center">
                    <Button
                      color="orange"
                      border={false}
                      onClick={handleSubmit}
                      title={t`Catre euplatesc.ro`}
                    />
                  </div>
                  <Field
                    name="agreement"
                    label={t`Declar pe propria raspundere ca sunt detinatorul de drept al cardului pe care il voi utiliza in vederea tragerii creditului.`}
                    component={Checkbox}
                    type="checkbox"
                    validate={isRequired()}
                    parse={value => (value === true ? value : undefined)}
                  />
                </>
              )}
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default ModalInstantPayment;
